import { Button } from '@mui/material';
import { exportOrdersToCSV } from 'common/utils';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

const ExportToCsvButton = () => {
  const currentTenantId = useSelector(({ auth }) => auth?.currentTenantId);
  const facilities = useSelector(({ pharmacy }) => pharmacy[currentTenantId]);
  const shippingOptions = useSelector(({ systemConfigs }) => systemConfigs.shippingOptions);
  const workQueueStore = useSelector(({ workQueue }) => workQueue);
  const selectedPreset = workQueueStore?.preset;
  const selectedWorkQueue = workQueueStore[selectedPreset];

  const { currentPage, pages } = selectedWorkQueue;
  const items = pages[currentPage] || [];

  const handleExport = () => exportOrdersToCSV(items, facilities, shippingOptions, selectedPreset);

  return (
    <Button variant='outlined' disabled={isEmpty(items)} onClick={handleExport}>
      Export
    </Button>
  );
};

export default ExportToCsvButton;
